import { render } from "./TwilioChangeRedirectOrderDialog.vue?vue&type=template&id=7a635e2c"
import script from "./TwilioChangeRedirectOrderDialog.vue?vue&type=script&lang=js"
export * from "./TwilioChangeRedirectOrderDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__